import React, { ReactElement } from 'react';
import { toast, TypeOptions } from 'react-toastify';

import AccreditedInvestorToaster from 'buyside/components/presentation/Toasters/accreditedInvestorToaster';
// import EventToaster from 'buyside/components/presentation/Toasters/eventToaster';
import JobApplicationToaster from 'buyside/components/presentation/Toasters/jobApplicationToaster';
import ParsedHtml from 'buyside/components/presentation/ParsedHtml/parsedHtml';
import SideNavigation from 'buyside/components/presentation/MainSiteNavigation/SideNavigation/sideNavigation';
import SiteMessageToaster from 'buyside/components/presentation/Toasters/siteMessageToaster';
import TopNavigation from 'buyside/components/presentation/MainSiteNavigation/TopNavigation/topNavigation';

import { persistentToast } from 'buyside/util/persistentToast';
// import { useIsEvent } from 'buyside/util/hooks/useWindowLocation';
import {
  Maybe,
  useMainNavigationCurrentUserQuery,
  useSiteMessageQuery
} from 'interfaces/graphql-typings';

import TrophyIcon from 'buyside/svgs/trophy.svg';

const getToastType = (type: string): TypeOptions => {
  if (['info', 'success', 'warning', 'error', 'default'].includes(type)) return type as TypeOptions;

  return 'info';
};

const MainSiteNavigation: React.FC<{
  currentUserFromRails: Maybe<any>;
  flashMessages: { id: string; type: string; text: string }[];
}> = ({ currentUserFromRails, flashMessages }) => {
  const { data } = useMainNavigationCurrentUserQuery({
    onCompleted: data => {
      if (!data?.currentUser) return;
      const {
        // canWriteIdeas,
        hasCompletedAccreditedInvestorProfile,
        profile,
        unaddressedApplicationsCount
      } = data.currentUser;
      if (unaddressedApplicationsCount) {
        persistentToast(<JobApplicationToaster count={unaddressedApplicationsCount} />, {
          toastId: 'unaddressed-applications-toast',
          disableIndefiniteDismiss: true
        });
      }
      if (profile?.isAccredited && !hasCompletedAccreditedInvestorProfile) {
        persistentToast(<AccreditedInvestorToaster />, {
          toastId: 'accredited-investor-toast'
        });
      }
    }
  });
  useSiteMessageQuery({
    onCompleted: data => {
      const siteMessage = data?.latestSiteMessage;
      if (siteMessage) {
        persistentToast(<SiteMessageToaster siteMessage={siteMessage} />, {
          toastId: `${siteMessage.id}-site-message-toast`,
          icon: siteMessage.isContest ? <TrophyIcon /> : undefined
        });
      }
    }
  });

  flashMessages.forEach(flash =>
    toast(
      <ParsedHtml html={flash.text}>
        {({ content }): ReactElement => <div>{content}</div>}
      </ParsedHtml>,
      {
        autoClose: 6000,
        theme: 'colored',
        toastId: flash.id,
        type: getToastType(flash.type)
      }
    )
  );

  // if (!useIsEvent()) {
  //   persistentToast(<EventToaster />, {
  //     toastId: 'event-toast',
  //     disableIndefiniteDismiss: true
  //   });
  // }

  const currentUser = data?.currentUser || currentUserFromRails;

  return (
    <>
      <TopNavigation currentUser={currentUser} />
      <SideNavigation currentUser={currentUser} />
    </>
  );
};

export default MainSiteNavigation;
